import {restoreMaterial} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../material-keys";

export function restoreMaterialMutationOptions() {
  return mutationOptions({
    mutationKey: materialMutationKeys.restoreMaterial,
    mutationFn: (id: string) => restoreMaterial(id),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: materialKeys.all});
    },
  });
}
